import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import I18n from '@fiverr-private/fiverr_context/src/I18n';

import './style.scss';

const xss = require('xss');

export const replaceBreakTags = (string, replacer = '\r\n') =>
    string.replace(/\s?(<br\s?\/?>)\s?/g, replacer);

class Description extends Component {

    constructor() {
        super();

        this.state = {
            descExpanded: false
        };

        this.onReadMoreClick = this.onReadMoreClick.bind(this);
    }

    onReadMoreClick(e) {
        e.preventDefault();

        this.setState({
            descExpanded: !this.state.descExpanded
        });

    }

    render() {
        const { descExpanded } = this.state;
        let desc = '';

        try {
            desc = xss(replaceBreakTags(this.props.userDescription), {
                whiteList: [],
                stripIgnoreTag: true,
                stripIgnoreTagBody: ['script', 'a']
            });
        } catch (error) {
            // fail silently
        }

        if (!desc.length) {
            return null;
        }

        const showReadMore = desc.length > 120;
        const descClassName = classNames('seller-desc', {
            'expanded': descExpanded || !showReadMore
        });

        return (
            <article className={descClassName}>
                <div className="inner">{desc}</div>
                {showReadMore &&
                    <a href="#!" className="read-more" onClick={this.onReadMoreClick}>
                        <I18n k={`gig_page_perseus.seller_card.read_more_text.${descExpanded ? 'less' : 'more'}`}/>
                    </a>
                }
            </article>
        );
    }
}

Description.propTypes = {
    userDescription: PropTypes.string
};

export default Description;
